import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: "Daily Serve has completely transformed how our team collaborates with clients. Everything is in one place and we've reduced email back-and-forth by 70%.",
  name: 'Sarah Johnson',
  role: 'Operations Director, Design Agency'
}, {
  quote: 'The platform is intuitive enough that our clients actually use it, which has been a game-changer for our project delivery timelines.',
  name: 'Michael Chen',
  role: 'Client Services Manager'
}, {
  quote: "We've tried many project management tools, but Daily Serve is the first one that truly combines client communication with internal workflows.",
  name: 'Emma Williams',
  role: 'Team Lead, Consulting'
}];
export const SocialProof = () => {
  return <section className="py-20 bg-white" data-id="element-230">
      <div className="container-custom" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-232">
          <h2 className="text-3xl font-bold text-brand-blue mb-4" data-id="element-233">
            Trusted by teams like yours
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-234">
            See what our customers say about Daily Serve.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-235">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-light rounded-lg p-6 shadow-sm relative" data-id="element-236">
              <div className="absolute top-4 left-4 text-5xl text-brand-teal opacity-20" data-id="element-237">
                "
              </div>
              <p className="text-gray-700 mb-6 relative z-10" data-id="element-238">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center" data-id="element-239">
                <div className="w-10 h-10 rounded-full bg-gray-300 mr-3" data-id="element-240"></div>
                <div data-id="element-241">
                  <p className="font-medium text-brand-blue" data-id="element-242">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-243">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
        <div className="mt-16" data-id="element-244">
          <p className="text-center text-gray-600 mb-8" data-id="element-245">
            Trusted by forward-thinking companies
          </p>
          <div className="flex justify-center flex-wrap gap-8" data-id="element-246">
            {[1, 2, 3, 4, 5].map((_, index) => <div key={index} className="w-32 h-12 bg-gray-200 rounded-md opacity-50" data-id="element-247"></div>)}
          </div>
        </div>
      </div>
    </section>;
};